import { render } from "./DocumentPreviewModal.vue?vue&type=template&id=579bc9a2&scoped=true&ts=true"
import script from "./DocumentPreviewModal.vue?vue&type=script&lang=ts"
export * from "./DocumentPreviewModal.vue?vue&type=script&lang=ts"

import "./DocumentPreviewModal.vue?vue&type=style&index=0&id=579bc9a2&lang=scss&scoped=true"

import exportComponent from "/opt/source/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-579bc9a2"]])

export default __exports__